<template>
    <v-card-text>
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.customer.SOCIETE"
                        label="Société"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.customer.TVA"
                        label="Numéro de TVA"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="9"
                    md="8"
                >
                    <v-text-field
                        v-model="$store.state.customer.RUE"
                        label="Rue"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.customer.CP"
                        label="Code postal"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="5"
                >
                    <v-text-field
                        v-model="$store.state.customer.LOCALITE"
                        label="Localité"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
	export default {
		name: "FormulaireRechercheClient",
		data: function () {
			return {
            }
        },
    }
</script>
